import courseWrapper from 'cccisd-laravel-assignment/dist/components/navigations/courseWrapper';
import campAirNavigation from '../../components/campAirNavigation';

const navigations = [campAirNavigation, courseWrapper];

export default navigations;
